import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { AddMemberPage } from './add-member.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, NgxDatatableModule, NgxTippyModule],
  declarations: [AddMemberPage],
})
export class AddMemberModule {}
